"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var installation_outline_component_1 = __importDefault(require("./sketch-elements/installation-outline.component"));
var installation_sketch_devices_component_1 = __importDefault(require("./sketch-elements/installation-sketch-devices.component"));
var installation_water_level_component_1 = __importDefault(require("./sketch-elements/installation-water-level.component"));
var installation_sketch_settings_component_1 = __importDefault(require("./sketch-elements/installation-sketch-settings.component"));
var installation_start_stop_levels_component_1 = __importDefault(require("./sketch-elements/installation-start-stop-levels.component"));
var use_highest_setting_hook_1 = __importDefault(require("./utils/use-highest-setting.hook"));
var InnerContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n\n  // Setting a default height. The combination with flex-grow means\n  // the container will not shrink if no height property is provided.\n  // Relative heights like '100%' or 'auto' does not fix this.\n  height: 0;\n"], ["\n  position: relative;\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n\n  // Setting a default height. The combination with flex-grow means\n  // the container will not shrink if no height property is provided.\n  // Relative heights like '100%' or 'auto' does not fix this.\n  height: 0;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.stroke;
});
var InstallationSketch = function (props) {
    var sketchDevices = props.sketchDevices, waterLevel = props.waterLevel, settings = props.settings, pumpStartLevel = props.pumpStartLevel, pumpStopLevel = props.pumpStopLevel;
    var ref = react_1.default.useRef(null);
    var _a = react_1.useState(0), height = _a[0], setHeight = _a[1];
    var _b = react_1.useState(0), width = _b[0], setWidth = _b[1];
    var highestSetting = use_highest_setting_hook_1.default(settings);
    react_1.useLayoutEffect(function () {
        var setDimensions = function () {
            if (!ref.current)
                return;
            var _a = ref.current.getBoundingClientRect(), height = _a.height, width = _a.width;
            setHeight(height);
            setWidth(width);
        };
        setDimensions();
        var handler = function () {
            setDimensions();
        };
        window.addEventListener('resize', handler);
        return function () { return window.removeEventListener('resize', handler); };
    }, []);
    var isReadyForRendering = height > 0 && width > 0;
    return (react_1.default.createElement(InnerContainer, { ref: ref }, isReadyForRendering && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(installation_outline_component_1.default, { height: height, width: width }),
        react_1.default.createElement(installation_sketch_devices_component_1.default, { height: height, width: width, devices: sketchDevices }),
        react_1.default.createElement(installation_water_level_component_1.default, { height: height, width: width, waterLevel: waterLevel, highestSetting: highestSetting }),
        react_1.default.createElement(installation_sketch_settings_component_1.default, { settings: settings, height: height, width: width, highestSetting: highestSetting }),
        react_1.default.createElement(installation_start_stop_levels_component_1.default, { startLevel: pumpStartLevel, stopLevel: pumpStopLevel, highestSetting: highestSetting, height: height, width: width })))));
};
InstallationSketch.displayName = 'InstallationSketch';
exports.default = InstallationSketch;
var templateObject_1;
